import React, { useState, useEffect } from "react";
import { useNavigate, useParams } from "react-router-dom";
import { Grid, Container, TextField } from "@mui/material";
import { CustomTitle } from "../../components/Custom/CustomTypography";
import CustomAppBar from "../../components/AppBar";
import { useTranslation } from "react-i18next";
import CustomButton from "../../components/Custom/CustomButton";
import useFormValidation from "../../components/Custom/FormValidation";
import { createCropValidationSchema } from "../../components/Custom/ValidationSchema";
import CustomCard from "../../components/Famer/GenericCard";
import { getProgramInput, getProgramInputTasks } from "../../api/programs";

const validationSchema = createCropValidationSchema();

export default function EditProgramInput() {
  const navigate = useNavigate();
  const { programInputId } = useParams();

  const [formData, setFormData] = useState({});
  const [programInputTasks, setProgramInputTasks] = useState([{}]);
  const { t } = useTranslation();
  const { errors, validate } = useFormValidation(formData, validationSchema);

  useEffect(() => {
    const loadProgram = async () => {
      setFormData(await getProgramInput(programInputId));
    };

    const loadProgramInputs = async () => {
      setProgramInputTasks(await getProgramInputTasks(programInputId));
    };

    loadProgram();
    loadProgramInputs();
  }, []);

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData((prevData) => ({ ...prevData, [name]: value }));
    validate({ ...formData, [name]: value });
  };

  const addProgramInputTask = async () => {
    navigate(`/programs/program-input/${programInputId}/add-task`);
  };

  return (
    <>
      <CustomAppBar />
      <Container maxWidth="xs">
        <div>
          <Grid
            container
            // spacing={1}
            justify="center"
            direction="column"
            style={{ marginTop: "10px" }}
          >
            <CustomTitle>{t("Edit Program Input")}</CustomTitle>

            <TextField
              margin="normal"
              required
              fullWidth
              type="text"
              label={t("Program Name")}
              name="name"
              value={formData.name || ""}
              onChange={handleChange}
              InputLabelProps={{ shrink: true }}
              error={!!errors.name}
              helperText={errors.name}
            />

            <div
              style={{
                overflowY: "auto",
                maxHeight: "calc(115vh - 300px)",
                textAlign: "center",
              }}
            >
              {programInputTasks.map((inputTask) => (
                <CustomCard
                  key={inputTask.id}
                  id={inputTask.id}
                  t={t}
                  data={{
                    [t("Name")]: inputTask.name,
                    [t("Application Type")]: inputTask.application_type,
                    [t("Activity")]: inputTask.activity,
                    [t("Quantity")]: inputTask.quantity,
                    [t("Unit")]: inputTask.unit,
                    [t("Start Date")]: inputTask.start_date,
                    [t("Due Date")]: inputTask.due_date,
                    [t("Comments")]: inputTask.comments,
                  }}
                  // handleView={handleView}
                  // handleEditClick={() => handleEditClick(crop.id)}
                  // handleDelete={() => handleDelete(crop.id)}
                />
              ))}
            </div>
            <CustomButton onClick={addProgramInputTask}>
              {t("Add Task")}
            </CustomButton>
            {/* <CustomButton onClick={handleSubmit}>{t("Save")}</CustomButton> */}
          </Grid>
        </div>
      </Container>
    </>
  );
}
